module.exports = __webpack_public_path__ + "img/domain-06.3f8b536e.png";